/**
 * @namespace SkipLinks
 * @aka SWRNEU.SkipLinks
 */
SWRNEU.SkipLinks = (function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'skiplinks';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
    KEYDOWN_DATA_API: 'keydown' + EVENT_KEY + DATA_API_KEY,
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '.skiplinks a'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var SkipLinks = function () {

    function SkipLinks(element) {
      COMMON.Utils._classCallCheck(this, SkipLinks);
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);
    }

    SkipLinks.prototype.handleClick = function handleClick(event) {
      const self = this;
      const $link = self.$element;
      const targetId = $link.attr('href');

      if (!targetId || targetId.charAt(0) !== '#') {
        return;
      }

      const target = document.querySelector(targetId);
      if (!target) {
        return;
      }

      //Fokus setzen OHNE Scrollen
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }

    // static
    SkipLinks._jQueryInterface = function _jQueryInterface(action) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        if (!data) {
          data = new SkipLinks(this);
          $(this).data(DATA_KEY, data);
        }
        if (typeof action === "string") {
          if (data[action] === undefined) {
            throw new Error('No method named "' + action + '"');
          }
          data[action]();
        }
      });
    };

    return SkipLinks;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(document).on(Event.CLICK_DATA_API, Selector.DATA_SPY, function (event) {
    if(this.href.indexOf('#playerbar') !== -1 || this.href.indexOf('#content') !== -1) {
      //Nur im Falle der Playerbar und des Contents verhindern wir das Standardverhalten,
      //damit die Seite nicht scrollt, sondern nur der Fokus auf die Playerbar/den Content
      //gesetzt wird. Wenn gescrollt würde, würde die Playerbar nach unten wegscrollen,
      //was nicht gewünscht ist.
      event.preventDefault();
      event.stopPropagation();
      SkipLinks._jQueryInterface.call($(this), 'handleClick', event);
    }
  });


  $(document).on(Event.KEYDOWN_DATA_API, Selector.DATA_SPY, function (event) {
    if(this.href.indexOf('#playerbar') !== -1 || this.href.indexOf('#content') !== -1) {
      //Nur im Falle der Playerbar und des Contents verhindern wir das Standardverhalten,
      //damit die Seite nicht scrollt, sondern nur der Fokus auf die Playerbar/den Content
      //gesetzt wird. Wenn gescrollt würde, würde die Playerbar nach unten wegscrollen,
      //was nicht gewünscht ist.
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        event.stopPropagation();
        SkipLinks._jQueryInterface.call($(this), 'handleClick', event);
      }
    }
  });


  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = SkipLinks._jQueryInterface;
  $.fn[NAME].Constructor = SkipLinks;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return SkipLinks._jQueryInterface;
  };

  return SkipLinks;

})(window.jQuery);
